// Home hero carousel: crossfades .home-hero__slide elements on a timer (section setting,
// default 10s). The dash indicators are jump buttons; the active dash's green fill animates
// over the interval via CSS (--hero-autoplay). Autoplay pauses while the tab is hidden and
// is disabled entirely under prefers-reduced-motion (dash shows a static full fill instead).
// In the theme editor, selecting a slide block shows that slide and pauses rotation.
(() => {
  const mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('.home-hero[data-carousel]').forEach((root) => {
    const slides = [...root.querySelectorAll('.home-hero__slide')];
    const dots = [...root.querySelectorAll('.home-hero__dot')];
    if (slides.length < 2) return;

    const interval = (parseFloat(root.dataset.autoplaySeconds) || 10) * 1000;
    let index = 0;
    let timer = null;
    let paused = false; // theme-editor block selection

    const show = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => {
        s.classList.toggle('is-active', n === index);
        s.setAttribute('aria-hidden', n === index ? 'false' : 'true');
      });
      dots.forEach((d, n) => {
        d.classList.remove('is-active');
        d.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
      const active = dots[index];
      if (active) {
        void active.offsetWidth; // restart the fill animation from 0
        active.classList.add('is-active');
      }
    };

    const stop = () => {
      clearTimeout(timer);
      timer = null;
    };

    const queue = () => {
      stop();
      if (paused || mqReduce.matches || document.hidden) return;
      timer = setTimeout(() => {
        show(index + 1);
        queue();
      }, interval);
    };

    dots.forEach((d, n) => {
      d.addEventListener('click', () => {
        show(n);
        queue(); // manual jump restarts the clock
      });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else { show(index); queue(); } // re-sync the fill with the fresh timer
    });

    if (window.Shopify && window.Shopify.designMode) {
      root.closest('.shopify-section')?.addEventListener('shopify:block:select', (e) => {
        const i = slides.findIndex((s) => s.contains(e.target) || s === e.target);
        if (i > -1) {
          paused = true;
          stop();
          show(i);
        }
      });
      root.closest('.shopify-section')?.addEventListener('shopify:block:deselect', () => {
        paused = false;
        queue();
      });
    }

    queue();
  });
})();
